import { gql } from '@apollo/client';

export const DELETE_DOCUMENT_TEMPLATE = gql`
  mutation deleteDocumentTemplate($input: DeleteDocumentTemplateInput) {
    deleteDocumentTemplate(input: $input) {
      commandId
    }
  }
`;
